interface DeleteRepPopupProps {
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * Delete Representative confirm — the shared DeletePopupView
 * (`/static/mvc/view/delete_popup` + delete_popup.tmpl) instantiated by
 * SalesRepUnitView.openDeletePopup with the EXACT title/copy and an empty
 * `name` (§3.9 / parity 83). Esc closes via the global popup keys
 * (`button[name=cancel_delete]` — the popup's own document keyup parity);
 * neither button carries autofocus, so ENTER is a no-op (legacy parity).
 */
const DeleteRepPopup = ({ onConfirm, onClose }: DeleteRepPopupProps) => (
  <div className="popup-wrapper width-small active">
    <div className="popup-content delete-popup">
      <h2 className="popup-heading">Delete Representative?</h2>
      <div className="popup-content-part">
        <p>
          If you choose to Delete, all Representative information including commission
          information will be lost and will not be recoverable.
        </p>
        <ul className="deleted-items">
          <li className="model-name" />
        </ul>
      </div>
      <div className="popup-control-buttons">
        <button className="btn right not-highlighted-btn" name="confirm_delete" onClick={onConfirm}>
          Delete
        </button>
        <button
          className="btn right btn_cancel highlighted-btn"
          id="btn_cancel"
          name="cancel_delete"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
);

export default DeleteRepPopup;
